import { uiRows } from './types-def.js';
/** `web/types` (1.B-2): user-defined types and fields. */
export const TYPES_INTERACTIONS = uiRows([
    {
        id: 'types.field.create-per-kind',
        module: 'web/types',
        behavior: 'A field of each kind can be created on a user-defined type',
        owner: '1.B-2',
        since: 'exit-1a',
    },
    {
        id: 'types.field.conversion-preview',
        module: 'web/types',
        behavior: 'Converting a field to another kind shows a preview of every value first',
        owner: '1.B-2',
        since: 'exit-1a',
    },
    {
        id: 'types.retype.report',
        module: 'web/types',
        behavior: 'Retyping a document shows a report before anything changes',
        owner: '1.B-2',
        since: 'exit-1a',
    },
]);
//# sourceMappingURL=types.js.map